import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  drawer: {
    flexShrink: 0,
    whiteSpace: 'nowrap',
    overflowX: 'hidden',
  },
  drawerPaper: ({ offset }) => ({
    border: 'none',
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 0,
    paddingBottom: 0,
    overflowX: 'hidden',
    paddingLeft: 0,
    paddingRight: 0,
    top: `${offset}px`,
    maxHeight: `calc(100% - ${offset}px)`,
  }),
  drawerOpen: {
    width: '290px',
    [theme.breakpoints.up('lg')]: {
      width: 290,
    },
  },
  drawerClose: {
    width: 74,
  },
  menuClosed: {
    '& > div > div > div': {
      paddingLeft: '25px !important',
      '& span': {
        display: 'none',
      },
    },
  },
  drawerPaperMobile: {
    width: '100vw',
    height: '100vh',
    paddingTop: '0px !important',
  },
  logoContainer: ({ menuOpen }) => ({
    padding: menuOpen ? '20px 16px' : '5px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: menuOpen ? 'row' : 'column',
  }),
  toggleButton: {
    padding: 8,
    '&:hover': {
      backgroundColor:
        theme.palette.mode === 'dark'
          ? 'rgba(255, 255, 255, 0.08)'
          : 'rgba(0, 0, 0, 0.04)',
    },
  },
  headerSeparator: ({ menuOpen }) => ({
    margin: menuOpen ? 0 : '10px 5px 25px',
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.12)'
        : 'rgba(0, 0, 0, 0.12)',
  }),
  popoverPaper: {
    backgroundColor: theme.palette.mode === 'dark' ? '#1a202c' : '#ffffff',
    border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)'}`,
    borderRadius: 8,
    boxShadow:
      theme.palette.mode === 'dark'
        ? '0 10px 25px rgba(0, 0, 0, 0.3)'
        : '0 10px 25px rgba(0, 0, 0, 0.1)',
    marginLeft: 8,
    minWidth: 180,
  },
  appBar: {
    backgroundColor: theme.palette.background.paper,
    padding: 0,
    [theme.breakpoints.up('md')]: {
      width: '100%',
    },
  },
  toolbar: {
    minHeight: 62,
    justifyContent: 'space-between',
  },
  toolbarGutters: {
    paddingRight: 15,
    paddingLeft: 15,
  },
  menuButton: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  materialIcon: {
    fontSize: '30px',
    margin: '0 -3px',
  },
  toggleMenuIcon: {
    cursor: 'pointer',
    '&:hover': {
      borderRadius: '100%',
      background:
        theme.type === 'dark' ? '#3c3c3c' : theme.palette.lightGray.main,
      transition: 'all .2s ease-in-out',
    },
  },
}));
